import gql from 'graphql-tag';
import { memberGQLFields } from '../network/index.js';
import { leaderboardGQLFields, } from './leaderboard.fields.js';
export function getLeaderboardGQLQuery(fields) {
    return gql `
    query getLeaderboard(
      $input: ReportInput!
    ){
      leaderboard(input: $input) {
        ${memberGQLFields(fields)}
      }
    }
  `;
}
export const getLeaderboardWithScoresGQLQuery = (fields) => gql `
  query LeaderboardWithScores(
    $includeAuthMember: Boolean!
    $input: ReportInput!
  ) {
    leaderboardWithScores(
      includeAuthMember: $includeAuthMember
      input: $input
    ) {
      ${leaderboardGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=leaderboard.gql.js.map